import React from 'react';

export const TagIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.48622V12.7073C12 13.0362 11.8627 13.3696 11.5778 13.6254C11.2981 13.8766 10.9318 14.0044 10.5605 13.9999H3.43947C3.07324 13.9999 2.70193 13.8766 2.42218 13.6254C2.14242 13.3742 2.00509 13.0408 2 12.7073L2.00509 4.49079C2 4.15737 2.14242 3.82853 2.42218 3.57733L5.98271 0.380227C6.5473 -0.126742 7.4527 -0.126742 8.01729 0.380227L11.5778 3.57733C11.8576 3.82853 12 4.15737 12 4.48622ZM7 4C7.55228 4 8 3.55228 8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3C6 3.55228 6.44772 4 7 4Z"
      fill="#757575"
    />
  </svg>
);
